import { useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { format, startOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Tabs, Spin, Table } from 'antd';
import async from "async"
import 'antd/dist/antd.min.css'
import StorageService from "../../../utils/storage.service";
import Loading from "../../customer/Loading";
import _ from "lodash"


const ReportPhucVuCheo = () => {
    const title = "Phục vụ chéo"
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(new Date())), "yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [isExport, setIsExport] = useState(false)
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState([])
    const [keyword, setKeyword] = useState([])
    const [userAdmin, setUserAdmin] = useState(JSON.parse(StorageService.getItem("user_info")))
    const [showLoading, setShowLoading] = useState(false)
    const [optionCategory, setOptionCategory] = useState([])
    const [catId, setCatId] = useState(0)
    const [pageSize, setPageSize] = useState(10)

    const handleChange = (e) => {
        setPageSize(e.pageSize)
    }

    const handleRangeDate = (sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }
    const handleStore = (x) => {
        setStore(x)
    }

    const handleCategory = (x) => {
        setCatId(x)
    }
    const fetchData = async (sD, eD, s) => {
        const { users, data } = await async.parallel({
            users: (cb) => {
                axiosService(`api/reports/store/users/${store}`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            },
            data: (cb) => {
                axiosService(`api/reports-view/package-using-store?startDate=${sD}&endDate=${eD}&storeId=${store}&keyword=${keyword}&catId=${catId}&type=1`, "GET").then(rs => {
                    const { data } = rs
                    cb(null, data)
                })
            }
        })
        if (data.code === 200) {
            setLoading(false)
            const { dataTable } = data.data
            setTable(_.map(dataTable, (item, index) => ({...item, id: index + 1,})))
        }

    }
    useLayoutEffect(() => {
        setLoading(true)
        fetchData(startDate, endDate, store)
    }, [startDate, endDate, store, keyword, catId])

    const columns = [
        {
            title: 'Ngày sử dụng',
            dataIndex: 'date',
            render: (data) => {
                return (
                    <>
                        <p className="text3">{data}</p>
                    </>
                )
            },
        },
        {
            title: 'Mã hoá đơn',
            dataIndex: 'order_code',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'customer_full_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'customer_mobile',
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{data}</p>
                )
            },
        },
        {
            title: 'Tên sản phẩm',
            dataIndex: 'product_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'Mã thẻ',
            dataIndex: 'package_code',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.total_paid - b.total_paid,
                multiple: 3,
            },
        },
        {
            title: 'Cơ sở bán thẻ',
            dataIndex: 'store_by_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.total_price - b.total_price,
                multiple: 3,
            },
        },
        {
            title: 'Cơ sở làm dịch vụ',
            dataIndex: 'store_using_name',
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
            sorter: {
                compare: (a, b) => a.total_price - b.total_price,
                multiple: 3,
            },
        },
    ];

    const tabItems = [
        {
            key: '1',
            label: 'Phục vụ hộ',
            children: (
                <Table 
                    columns={columns}
                    dataSource={table}
                    onChange={handleChange}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50', '100'] }}
                    scroll={{ x: 1300 }}
                    bordered
                    rowKey="id"
                />
            ),
        },
        {
            key: '2',
            label: '',
            children: (
                <Table 
                    columns={columns}
                    dataSource={table}
                    onChange={handleChange}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50', '100'] }}
                    scroll={{ x: 1300 }}
                    bordered
                    rowKey="id"
                />
            ),
        },
    ];
    const handleExportData = () => {
        setShowLoading(true)
      
        var url = `api/reports-view/package-using-store?startDate=${startDate}&endDate=${endDate}&storeId=${store}&keyword=${keyword}&catId=${catId}&type=2`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.location.href = res.data.data.url
                setShowLoading(false)
            }
        }).catch((error) => {
            setShowLoading(false)
        });
    }
    const onChangeKeyword = (e) => {
        setKeyword(e)
    }
    return (
        <div className={`container-fluid ${styles.background}`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} 
                store={store}
                handleStore={handleStore}
                title={title} type={"package-using-store"}
                csvData={table} isExport={isExport}
                handleExportData={handleExportData}
                onChangeKeyword={onChangeKeyword}
                header={
                    [
                        { label: 'Tên dịch vụ', key: "product_name" },
                        { label: "Nhóm dịch vụ", key: "category_name" },
                        { label: "Tiền thực thu dịch vụ", key: "total_paid" },
                        { label: "Số dịch vụ bán mới", key: "count_order" },
                        { label: "Doanh số thuần", key: "total_price" },
                    ]
                }
                userAdmin={userAdmin}
                optionCategory={optionCategory}
                handleCategory={handleCategory}
            />
            <Spin spinning={loading} tip="Đang tải...">
                <div className="mt-3">
                    <div style={{ backgroundColor: "white" }} className="p-2">
                        <Tabs defaultActiveKey="1" items={tabItems} />
                    </div>
                </div>
            </Spin>
            <Loading show={showLoading} />
        </div>
    )
}
export default ReportPhucVuCheo